import React from 'react'
import { SkinProductOption } from '../types/productTypes'
import { findInterfaceByItemNo, getDefaultSkinOrientation, resolveInterfaces } from '../products/productUtils'
import ConfigurableProductView, { ConfigurableProductButtonFrame } from './ConfigurableProductView'
import { getSkinErrorImage, getSkinPlaceholderImage } from '../data/test-data'
import ConfigurableProductButton from './ConfigurableProductButton'
import { ConfiguredInterface } from '../list/ListTypes'
import { ProductDataShape } from '../ProductDataShape'

export const SelectorProductItem: React.FC<{
  product: SkinProductOption
  configuredButtonIds: readonly ConfiguredInterface[]
  Products: ProductDataShape
  shadowScale?: number
  overrideImage?: string
  debugMode: boolean
  interfaceWarningIndices: readonly number[]
}> = ({
  product,
  configuredButtonIds,
  Products,
  shadowScale,
  overrideImage,
  debugMode,
  interfaceWarningIndices,
}) => {
  const resolvedButtons = resolveInterfaces(product, configuredButtonIds, Products, true)

  return (
    <>
      <ConfigurableProductView
        debugDescription={`${product.itemNo}\n${product.grid || 'no grid'}`}
        {...product}
        orientation={product.orientation}
        buttonCoordsOrientation={getDefaultSkinOrientation(product)}
        shadowScale={shadowScale}
        image={overrideImage ?? product.image}
        placeholderImage={getSkinPlaceholderImage(product, product.gridProduct)}
        errorImage={getSkinErrorImage(product, product.gridProduct)}
        debugMode={debugMode}
        renderButton={(props, buttonIndex, scale) => {
          const displayButton = findInterfaceByItemNo(resolvedButtons[buttonIndex].interfaceItemNo, Products.interfaces)

          let mechImageUrl: string | undefined = undefined
          const mechItemNo = displayButton.mechs[0]
          if (mechItemNo) {
            mechImageUrl = Products.mechMap[mechItemNo]?.image
          }

          return (
            <>
              {/*<ConfigurableProductButtonFrame {...props} scale={scale}>*/}
              {/*  <div style={{*/}
              {/*    border: '1px solid #ff0000',*/}
              {/*    borderRadius: '20%',*/}
              {/*    width: '100%',*/}
              {/*    height: '100%',*/}
              {/*    boxSizing: 'border-box',*/}

              {/*  }}>*/}
              {/*  </div>*/}
              {/*</ConfigurableProductButtonFrame>*/}
              {/* // <></> */}
              <ConfigurableProductButton
                baseScale={scale}
                {...props}
                backgroundImage={mechImageUrl}
                foregroundImage={displayButton.image}
                debugColorCode={displayButton.color}
              />

              {
                interfaceWarningIndices.includes(buttonIndex) && (
                  <ConfigurableProductButtonFrame
                    key={`dot-${buttonIndex}`}
                    {...props}
                    scale={scale}
                  >
                    <div className="dot warning" />
                  </ConfigurableProductButtonFrame>
                )
              }
            </>
          )
        }}
      />
      {/*<ConfigurableProductCanvasView*/}
      {/*  {...product}*/}
      {/*  orientation={product.orientation}*/}
      {/*  buttonCoordsOrientation={getDefaultSkinOrientation(product)}*/}
      {/*  image={overrideImage ?? product.image}*/}
      {/*  configuredButtons={resolvedButtons.map(item => inflateConfiguredInterface(item, Products))}*/}
      {/*  size={300}*/}
      {/*/>*/}
    </>
  )
}
